<template lang="pug">
  form(id="ghl-form" v-if="payment !== null")
    div.md-form-group(:class="{'invalid':errors.has('ghl_username')}")
      input.md-input(
      type="text"
      name="ghl_username"
      v-model="payment.meta.ghl_username"
      v-validate="'required'"
      data-vv-as="Username"
      :disabled="loading"
      ref="paymentName"
      )
      label Username
      span.form-error-msg(v-show="errors.has('ghl_username')") {{ errors.first('ghl_username') }}

    div.md-form-group(:class="{'invalid':errors.has('ghl_password')}")
      input.md-input(
      type="password"
      autocomplete="new-password"
      name="ghl_password"
      v-model="payment.meta.ghl_password"
      v-validate="'required'"
      data-vv-as="Password"
      :disabled="loading"
      )
      label Password
      span.form-error-msg(v-show="errors.has('ghl_password')") {{ errors.first('ghl_password') }}

    div.md-form-group.p-t-0
      label.multiselect-label Applicable outlets
      multiselect(
      name="outlets"
      v-model="payment.outlets"
      :options="outletList"
      placeholder="Type to search"
      label="name"
      :multiple="true"
      :loading="outletList.length === 0"
      :disabled="loading"
      :clear-on-select="false"
      :close-on-select="false"
      :hide-selected="true"
      track-by="id"
      )
      span.md-input-msg Leave empty if applicable to all outlets.
</template>

<script>
import FormMixin from '../form-mixin';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'GHL',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'ghl',
                meta: {},
                outlets: [],
            }),
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            if (this.payment.meta.ghl_password !== undefined) {
                payment.meta.ghl_password = this.payment.meta.ghl_password;
            }

            return Object.assign(payment, {
                name: 'GHL',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'ghl',
                outlets: this.payment.outlets.map(obj => obj.id),
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/ghl-form.vue